import { render, staticRenderFns } from "./AlarmComment.vue?vue&type=template&id=36d7836e"
import script from "./AlarmComment.vue?vue&type=script&lang=js"
export * from "./AlarmComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports